import React, { useRef } from 'react';
import { useCombinedRefs } from 'common';
import { ListItemText } from 'components/List';

export interface MoreButtonItemTextProps extends React.ComponentPropsWithRef<'div'> {
  /** children, displayed as text content within MoreButtonItem. Consider using plain text. */
  children: React.ReactNode;
}

/** MoreButton menu item which supports text.
 * Any other props will be provided to the wrapper element.
 */
const MoreButtonItemText = React.forwardRef<HTMLElement, MoreButtonItemTextProps>((props: MoreButtonItemTextProps, forwardedRef) => {
  const {
    children,
    ...otherProps
  } = props;
  const innerRef = useRef(null);
  const ref = useCombinedRefs(forwardedRef, innerRef);

  return <ListItemText ref={ref} {...otherProps}>{children}</ListItemText>;
});

MoreButtonItemText.displayName = 'MoreButtonItemText';

export default MoreButtonItemText;
